import React from 'react';
import { NavLink } from 'react-router-dom';

export const CartBreadcrumb = () => {
    return (
        <nav aria-label="breadcrumb">
            <div className="breadcrumb">
                <NavLink className="breadcrumb-item text-decoration-none" to="/">
                    Home
                </NavLink>
                <NavLink className="breadcrumb-item text-decoration-none" to="/search">
                    Shop
                </NavLink>
                <NavLink className="breadcrumb-item text-decoration-none" to="/cart">
                    Shopping cart
                </NavLink>
            </div>
        </nav>
    );
};
